import { render, staticRenderFns } from "./Fullscreen.vue?vue&type=template&id=879f4b1c&scoped=true"
import script from "./Fullscreen.vue?vue&type=script&lang=js"
export * from "./Fullscreen.vue?vue&type=script&lang=js"
import style0 from "./Fullscreen.vue?vue&type=style&index=0&id=879f4b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f4b1c",
  null
  
)

export default component.exports